import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CurrencyConfig {
  symbol: string;
  code: string;
  position: 'left' | 'right';
  decimalSeparator: string;
  thousandsSeparator: string;
  timezone?: string;
  dateFormat?: string;
  timeFormat?: string;
}

interface CurrencyStore {
  currency: CurrencyConfig;
  setCurrency: (currency: Partial<CurrencyConfig>) => void;
  syncFromRegionalConfig: (regionalConfig: any) => void;
}

export const useCurrencyStore = create<CurrencyStore>()(
  persist(
    (set) => ({
      currency: {
        symbol: '$',
        code: 'USD',
        position: 'left',
        decimalSeparator: '.',
        thousandsSeparator: ',',
        timezone: 'America/New_York',
        dateFormat: 'MM/DD/YYYY',
        timeFormat: 'hh:mm A',
      },
      setCurrency: (newCurrency) =>
        set((state) => ({
          currency: { ...state.currency, ...newCurrency },
        })),
      // Sincronizar desde la configuración regional
      syncFromRegionalConfig: (regionalConfig) => {
        if (!regionalConfig) {
          return;
        }

        // Buscar el país predeterminado
        const defaultCountry = regionalConfig.supportedCountries?.find(
          (c: any) => c.countryCode === regionalConfig.defaultCountry
        );

        if (defaultCountry) {
          const newTimezone = defaultCountry.timezone || regionalConfig.defaultTimezone;

          // FORZAR actualización - esto sobrescribe el localStorage
          set((state) => ({
            currency: {
              ...state.currency,
              symbol: defaultCountry.currencySymbol || '$',
              code: defaultCountry.currencyCode || 'USD',
              timezone: newTimezone,
              dateFormat: defaultCountry.dateFormat || 'MM/DD/YYYY',
              timeFormat: defaultCountry.timeFormat || 'hh:mm A',
            },
          }));
        }
      },
    }),
    {
      name: 'currency-storage',
      partialize: (state) => ({ currency: state.currency }),
    }
  )
);
